<template>
  <div>
    <v-list-item v-if="mofDue" :to="{name:'ReportsView',params:{back:[{text:'Dashboard',to:{name:'Dashboard'}}]},query:{to:'provinces/ON/reports/ReportsOntarioSpirits'}}"><v-icon>mdi-chevron-right</v-icon>Ontario Spirit Return to file</v-list-item>
    <v-list-item v-if="lcboDue" :to="{name:'ReportsView',params:{back:[{text:'Dashboard',to:{name:'Dashboard'}}]},query:{to:'provinces/ON/reports/ReportsOntarioLCBO'}}"><v-icon>mdi-chevron-right</v-icon>LCBO Distillery Reporting to file</v-list-item>
  </div>
</template>

<script>
import {add,format,lastDayOfMonth,set,lastDayOfQuarter} from 'date-fns';

export default {
  name: 'Outstanding',
  props: {
    value: {type:Boolean, required:true}
  },
  data() {
    return {
      lcboDue: false,
      mofDue: false,
      ontario: {}
    }
  },
  computed: {
    outstandingSettings() {
      return {reportingWarningDays:10, ...this.$store.getters.userSettings.dashboard?.outstandingSettings};
    }
  },
  async created() {
    const results = await this.$apiCall(`query Outstanding {
                                            ontarioPreferences {
                                              lcboPeriodEnd,mofPeriodEnd,lcboQuarterly
                                            }
                                          }`,
                                        {});
    if (!results.error)
      this.ontario = results.data.ontarioPreferences;

    this.refresh();
  },
  methods: {
    refresh() {
      if (this.$store.getters.company.permissions.includes('excise.file')) {
        const nextFilingForPeriodEnd = format(lastDayOfMonth(add(new Date(),{months:-1})),'yyyy-MM-dd'); // end of last month
        const nextLCBOFilingForPeriodEnd = this.ontario.lcboQuarterly
                                       ? format(lastDayOfQuarter(add(new Date(),{quarters:-1})),'yyyy-MM-dd')  // end of last quarter
                                       : nextFilingForPeriodEnd; // end of last month

        if (this.ontario.lcboPeriodEnd >= nextLCBOFilingForPeriodEnd)   // already filed
          this.lcboDue = false;
        else if (this.ontario.lcboPeriodEnd < format(lastDayOfMonth(add(new Date(),{months:-2})),'yyyy-MM-dd'))
          this.lcboDue = true;
        else {
          let baseDate = new Date();
          if (this.ontario.lcboQuarterly)
            baseDate = lastDayOfQuarter(baseDate);
          const warningDate = format(add(set(baseDate,{date:20}),{days:-this.outstandingSettings.reportingWarningDays}),'yyyy-MM-dd');
          if (warningDate > format(new Date(),'yyyy-MM-dd'))
            this.lcboDue = false;
          else
            this.lcboDue = true;
        }

        if (this.ontario.mofPeriodEnd >= nextFilingForPeriodEnd)   // already filed
          this.mofDue = false;
        else if (this.ontario.mofPeriodEnd < format(lastDayOfMonth(add(new Date(),{months:-2})),'yyyy-MM-dd'))
          this.mofDue = true;
        else {
          const warningDate = format(add(set(new Date(),{date:20}),{days:-this.outstandingSettings.reportingWarningDays}),'yyyy-MM-dd');
          if (warningDate > format(new Date(),'yyyy-MM-dd'))
            this.mofDue = false;
          else
            this.mofDue = true;
        }
      }
      this.$emit('input', this.lcboDue && this.mofDue);
    }
  }
}
</script>